import React from "react";
import "./Navbar.css";

export default function Header() {
  return (
    <header className="navbar-main fixed-top">
      <nav className="navbar navbar-expand-lg navbar-light bg-white w-100">
        <div className="container-fluid">
          <a className="navbar-brand ms-100" style={{marginLeft:"40px"}} href="/">
            <span className="bg-dark text-white p-1 me-2">FA</span>Fakhar Autos Workshop
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{marginLeft:"auto"}}>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link about" href="/about">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link gallery" href="/Gallery">Gallery</a>
              </li>
              <li className="nav-item">
                <a className="nav-link services" href="/services">Services</a>
              </li>
              <li className="nav-item">
                <a className="nav-link contact" href="/contact">Contacts</a>
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center ms-auto me-100" style={{marginRight:"40px"}}>
              <a
                href="tel:+923351908270"
                className="btn btn-secondary rounded ms-2 cta-btn-main"
              >
                <i className="fas fa-phone-alt me-2"></i>
                <span >Call Us</span>
              </a>
            </div>
        </div>
      </nav>
    </header>
  );
}


